import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

const PageContext = createContext();

function PageContextProvider({ children }) {
    const [activityRegisterPage, setActivityRegisterPage] = useState({});
    const [actionListPage, setActionListPage] = useState({});

    const location = useLocation();
    const [previousPath, setPreviousPath] = useState(null);

    useEffect(() => {
        const storedPrev = sessionStorage.getItem("prevPath");
        setPreviousPath(storedPrev);

        // Store current path as the "prev" for the next navigation
        sessionStorage.setItem("prevPath", location.pathname);
    }, [location.pathname]);

    const updateActivityRegisterPage = (page) => {
        if (page) {
            setActivityRegisterPage(page);
        }
    }

    const updateActionListPage = (page) => {
        if (page) {
            setActionListPage(page);
        }
    }

    const clearContext = () => {
        setActivityRegisterPage({});
        setActionListPage({});
    }

    return (
        <PageContext.Provider value={{
            activityRegisterPage: activityRegisterPage,
            actionListPage: actionListPage,
            previousPath: previousPath,
            updateActivityRegisterPage: updateActivityRegisterPage,
            updateActionListPage: updateActionListPage,
            clearContext: clearContext
        }}>
            {children}
        </PageContext.Provider>
    );
}

export { PageContext, PageContextProvider };